module.exports = __webpack_public_path__ + "img/Scoops-min.b00ceb12.png";